export const locale = {
  lang: "fr-CA",
  data: {
    CATERER: {
      GRAPHICS: "Graphiques",
      LOGO: "Logo",
      UPLOAD_LOGO: "Téléverser Logo",
      UPLOAD_LOGO_SUCCESS: "Logo téléversé avec succès",
      UPLOAD_LOGO_DIMENSION: "largeur et hauteur minimale: 200px",
      UPLOAD_HEADER: "Téléverser Header",
      UPLOAD_HEADER_SUCCESS: "Header téléversé avec succès",
      UPLOAD_HEADER_DIMENSION: "largeur minimale: 600px, hauteur minimale: 120px",
      SELECT_LOCALES: "Choissiser une ou plusieurs langue pour votre organisation dans la liste ci-dessous.",
      SELECT_DEFAULT_LOCALES: "Choisir la langue par défaut pour cette organisation",
      CURRENT_LOGO: "Logo",
      CURRENT_REPORT_HEADER: "En-tête des rapports",
      CURRENT_REPORT_ASSETS: "Éléments graphique des rapports",
      NEXT_PAYMENT_DATE: "Prochain paiement",
      OPEN_SINCE: "Ouvert depuis",
      TOTAL_USER: "Nombre d'utilisateurs",
      CURRENT_COST: "Coût mensuel actuel",
      RESPONSIBLE_USER: "Utilisateur responsable",
      ORG_LIST: "Liste des traiteurs",
      ORG_TYPE: "Type",
      ORG_TYPE_INTERNAL: "Organisation Interne",
      ORG_TYPE_IDENTITY: "Identité d'organisation",
      IDENTITY_ADD: "Ajouter une identité",
      IDENTITY_DELETE_SUCCESS: "Identité supprimée avec succès!",
      TRIAL: "Trial",
      SELECT_EMPLOYEE: "Sélectionner un utilisateur",
      CATERER: "Traiteur",
      GT_APP_LOGOS: "Logos GT-APP",
      LOGO_WHITE: "Logo Blanc (pour les thèmes sombres)",
      LOGO_COLOR: "Logo Couleur (pour les fonds clairs / Rapports)",
      UPLOAD_ASSET: "Téléverser",
      UPLOAD_ASSET_SUCCESS: "Image téléversée avec succès",
      UPLOAD_ASSET_ERROR: "Erreur lors du téléversement de l'image",
      LOGO_PNG_ONLY: "PNG seulement, 272x72 pixels",
      LOGO_INVALID_DIMENSIONS: "L'image doit faire 272x72 pixels",
      LOGO_INVALID_FORMAT: "Seuls les fichiers PNG sont acceptés",
      DEFAULT_PRODUCT_IMAGE: "Image produit par défaut",
      PRODUCT_DEFAULT_PNG_ONLY: "PNG seulement, 250x250 pixels",
      PRODUCT_DEFAULT_INVALID_DIMENSIONS: "L'image doit faire 250x250 pixels",
    },
  },
};
